<template>
  <div class="hello">
    <van-sticky class="item-pop">
      <div style="position: relative; max-width: 640px; left:auto; margin: 0 auto;">
        <van-nav-bar style="height:54px;background: rgb(53, 120, 229)" :border="false" @click-left="gotohome" safe-area-inset-top>
          <template #left>
            <van-icon style=" margin-top:10px; font-weight: 900;" name="arrow-left" color="#FFFFFF" size="25"/>
          </template>
          <template #title>
            <div style="width:60%;position: absolute; left:50px; top: 0;">
              <van-search
                v-model="shopName"
                shape="round"
                width="200px"
                background="rgb(53, 120, 229)"
                placeholder="請輸入搜尋關鍵詞"
                @focus="gotosearch()"
              />
            </div>
          </template>
          <template #right>
            <div style=" width:100px;  height:54px; position: absolute; right:8px; top: 0;">
              <van-badge style=" margin-top:10px;" :content="cartItemNum">
                <div class="child">
                <van-icon name="cart" color="#FFFFFF" size="28" @click="gotocart"/>
                </div>
              </van-badge>
              <van-icon style="margin-left: 10px;  margin-top:15px;" name="share" color="#FFFFFF" size="30" @click="showShare = true"/>
            </div>

          </template>
        </van-nav-bar>
      </div>
  </van-sticky>
  <div v-if="result" style="background-color:#f4f5f5;">
    <van-swipe  class="my-swipe" :autoplay="3000" @change="onChange">
      <van-swipe-item v-for="(item,index) in itemData.ItemMainImg" :key="index"><van-image width="100%" height="100%" fit="fill" :src="item.url" @click="onMainImgPreview(index)"/></van-swipe-item>
      <template #indicator>
        <div class="custom-indicator">{{ current + 1 }}/4</div>
      </template>
    </van-swipe>
    <van-cell-group style="border-radius:20px; margin-left:7px; margin-right:7px;" :border="false">
      <van-cell style="border-radius:20px;" size="large" value="内容" >
        <template>
          <span class="Price-title">{{itemData.Currency}}${{itemData.Price}}</span>
          <span class="OldPrice-title">{{itemData.Currency}}${{(parseInt(itemData.Price) + 200)}}</span><span  class="up-title">起</span>
          <span style="float:right; font-size:0.6rem; color:gray">售出:{{itemData.sales}}單</span><br>
          <van-tag type="primary " size="medium">貨到付款</van-tag>
          <van-tag type="success" size="medium">宅配到府</van-tag>
          <van-tag type="danger" size="medium">客服減免</van-tag>
          <van-tag type="warning" size="medium">七日鑒賞期</van-tag>
        </template>
      </van-cell>
      <van-cell :border="false">
        <span style="font-size:14px; font-weight:900;">{{itemData.ItemTitle}}</span><br>
        <span style="font-size:12px; font-weight:400;color:#606266;"><p style="line-height:1rem; ">{{itemData.Description}}</p></span>
      </van-cell>
      <van-cell :border="false">
        <template #title>
          <div style="display:inline-flex;">
            <span v-if="itemData.Category">分類 | {{itemData.Category[0] }}|{{ itemData.Category[1] }}</span>
          </div>
        </template>
      </van-cell>
      <van-cell is-link  :border="false">
        <template #title>
          <div style="display:inline-flex">
            <span>出貨 | </span><div style="margin-left:2px;margin-top:2px;"><van-image width="16px" height="16px" fit="fill" src="/static/icon_speed.svg"/></div> <span>&nbsp;下訂後<font style="color:#ee0a24">1</font>個工作天出貨</span>
          </div>
        </template>
      </van-cell>
      <van-cell :border="false">
        <template #title>
          <div style="display:inline-flex">
            <span>配送 | 宅配到府&nbsp;</span>
            <div style="margin-left:2px;margin-top:2px;"><van-image width="16px" height="16px" fit="fill" src="/static/icon_delivery.svg"/></div>
            <span>&nbsp;超商取貨&nbsp;</span>
            <div style="margin-left:2px;margin-top:2px;"><van-image width="16px" height="16px" fit="fill" src="/static/icon_shop.svg"/></div>
          </div>
        </template>
      </van-cell>
      <van-cell :border="false">
        <template #title>
          <span>運費 | 台灣本島<font style="font-weight:500; color:#ee0a24">NT$100</font>，滿<font style="font-weight:500; color:#ee0a24">NT$900</font>免運</span>
        </template>
      </van-cell>
      <van-cell  :border="true">
        <template #title>
          <div style="display:inline-flex">
            <span>付款 | 信用卡支付&nbsp;</span>
            <div style="margin-left:2px;margin-top:1px;"><van-image width="20px" height="20px" fit="fill" src="/static/icon_card.svg"/></div>
            <span>&nbsp;貨到付款&nbsp;</span>
            <div style="margin-left:2px;margin-top:1px;"><van-image width="20px" height="20px" fit="fill" src="/static/icon_cash.svg"/></div>
          </div>
        </template>
      </van-cell>
      <van-cell style="border-radius:20px;" is-link :border="false">
        <template #title>
          <div style="display:inline-flex">
            <span>保障 | </span>
            <div style="margin-left:2px;margin-top:3px;"><van-image width="16px" height="16px" fit="fill" src="/static/icon_rights.svg"/></div>
            <span>&nbsp;<font style="color:#ee0a24">7</font>日鑒賞期，無憂退換</span>
          </div>
        </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group style="border-radius:20px; margin-left:7px; margin-right:7px;" :border="false">
    <van-cell style="margin-top:5px; border-radius:20px;" :border="false">
      <template>
        <span class="Details-title">好物推介</span>
      </template>
    </van-cell>
    <van-cell class="recomm-cell" :border="false">
      <van-swipe class="recomm-swipe" :autoplay="3000" indicator-color="#dddfe4">
        <van-swipe-item v-for="(data,key) in recomm" :key="key">
          <van-grid  style="padding-bottom: 10px;" :column-num="2" clickable :border="false">
            <van-grid-item v-for="(item,index) in data" :key="index" @click="gotoItem(item.ShortLink)">
              <div style="width:100%; height: 9rem;">
                  <van-image width="100%" height="100%" :src="item.banner" fit="fill"/>
                </div>
              <div style="height:40px; display:inline">
                <p style="float:left;  font-size:10px;font-weight:900; line-height: 11px; ">{{ item.ItemTitle }}</p>
              </div>
              <div style="width:100%;height:20px;">
                <span style="float:left; font-size:10px; font-weight:900;color: #3578e5;">{{ item.Currency }}${{ item.Price }}起</span>
                <span style="float:right; font-size:10px;color: gray;">售出：{{ item.sales }}</span>
              </div>
            </van-grid-item>
          </van-grid>
        </van-swipe-item>
      </van-swipe>
    </van-cell>
  </van-cell-group>
  <van-cell-group style="border-radius:20px; margin-left:7px; margin-right:7px;" :border="false">
    <van-cell style="margin-top:5px; border-radius:20px;" size="large">
      <template>
        <span class="Details-title">歷史訂單</span>
      </template>
    </van-cell>
    <van-cell v-for="(item,index) in orderData.slice((currentPage-1)*5,currentPage*5)" :key="index" size="large">
      <span style="font-size:0.5rem; font-weight:900; color:#3578e5;">{{item.name}}</span>
      <span style="font-size:0.5rem; font-weight:900; color:#3578e5;">{{item.phone}}</span>
      <span style="font-size:0.5rem; font-weight:900; color:#3578e5;">{{item.city}}</span>
      <span style="font-size:0.5rem; font-weight:900; color:#3578e5;">{{item.region}}</span>
      <span style="float:right; font-size:0.5rem; font-weight:900; color:#3578e5;">{{item.date}}</span><br>
      <span style="font-size:0.5rem;">{{item.content}}</span>
    </van-cell>
    <van-cell style="margin-top:5px; border-radius:20px;" size="large">
      <van-pagination v-model="currentPage" :total-items="total" :items-per-page="5" :show-page-size="5">
        <template #prev-text>
          <van-icon name="arrow-left" />
        </template>
        <template #next-text>
          <van-icon name="arrow" />
        </template>
      </van-pagination>
    </van-cell>
    </van-cell-group>
<!--     <div style="margin-left:10px; margin-top:10px;">
      <div class="fb-page" data-href="https://www.facebook.com/sctwshop" data-tabs=""  data-width="355" data-height="70" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true"><blockquote cite="https://www.facebook.com/sctwshop" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/sctwshop">小泉士多</a></blockquote></div>
    </div> -->
    <van-cell style="margin-top:5px;" size="large">
      <template>
        <span class="Details-title">商品詳情</span>
      </template>
    </van-cell>
    <div class="details" >
      <vdetails :details="details"/>
    </div>
    <div style="margin-top:20px; padding-bottom:50px;">
      <van-collapse v-model="activeNames">
        <van-collapse-item title="用戶須知" name="1">本產品的實際使用效果根據個人情況決定，不保證每位用戶都能享受到所宣傳的效果。若有疑問請通過在線客服聯絡我們，本公司享有最終解釋權。</van-collapse-item>
        <van-collapse-item title="物流配送" name="2">貨物一般在訂單確認的5~10個工作日送達，出現突發狀況可能會有所延遲。貨物送達前都會提前聯絡客戶，請保持電話暢通。</van-collapse-item>
        <van-collapse-item title="退貨流程" name="3">確認收貨—申請退換貨—客服審核通過—用戶寄回商品—倉庫簽收驗貨—退換貨審核—退款/換貨；退換貨請註明：訂單號、姓名、電話。</van-collapse-item>
        <van-collapse-item title="關於我們" name="4">小泉士多致力於為客戶提供優質的商品，並以此爲目標不斷努力。爲了保障您的權益，購物前請認準我們的官方網站和社交媒體。</van-collapse-item>
        <van-collapse-item title="聯絡我們" name="5">如果您有問題需要幫助，可以通過在線客服與我們聯絡，或前往我們的Facebook主頁。客服電郵：support@koizumishop.com</van-collapse-item>
      </van-collapse>
    </div>
    <div style="margin:0 auto; text-align:center; padding-bottom:100px;">
      <span style="color: #606266; font-size:0.6rem;">@小泉士多 KOIZUMISHOP</span>
      <div style="margin-top:20px;">
        <ul style="display: inline-flex;list-style: none;"><li style="margin-right: 14px;"><a style="color:#606266; text-decoration: none;font-size:0.6rem;" href="/privacy">隱私政策</a></li><li><a style="color:#606266; text-decoration: none;font-size:0.6rem;" href="/terms">服務條款</a></li></ul>
      </div>
    </div>
    <van-goods-action style="max-width:640px; margin:0 auto; z-index:1000">
      <van-goods-action-icon icon="chat-o" text="客服" @click="openchat()"/>
      <van-goods-action-icon icon="cart-o" text="購物車" :badge="cartItemNum" @click="gotocart"/>
      <van-goods-action-button class="confirm-btn" type="danger" text="立即購買" @click="show=true"/>
    </van-goods-action>
    <!-- 图标位置 -->
    <van-share-sheet class="share-pop"  v-model="showShare" title="分享商品" :options="options" @select="onSelectShare" />
    <van-popup class="item-pop" v-model="show" get-container="#app" round position="bottom" >
      <template>
        <div style="position:fixed; z-index:900; width:100%; max-width: 640px;">
          <van-icon style="position:absolute; top:5px; right:5px; z-index:100" size="25" name="close" @click="show=false"/>
          <van-cell style=" border-top-left-radius:20px; border-top-right-radius:20px; width: 100%;" size="large" :border="false">
            <template>
              <div style="display: inline-flex;">
                <van-image style="margin-right:10px;" width="60px" height="60px" fit="fill" :src="itemData.banner"/>
                <div style="display:block; padding-bottom: 10px;">
                  <span class="Price-title">NT${{specprice}}</span><br>
                  <div class="lo-main" :class="[sharkFlag ?'my-shark' :'']" id="myShark">
                    <van-tag v-show="show" type="danger" style=" margin-top:5px; border-radius:5px; min-width:210px; max-width:450px; height: 60px;" color="linear-gradient(to right, #ff6034, #ee0a24)">
                      <span class="Cost-title">NT</span><span class="Cost-Price">$35</span>
                      <span class="Cost-Menu">下單後聯絡客服立減</span>
                    </van-tag>
                  </div>
                </div>
              </div>
            </template>
          </van-cell>
        </div>
        <div style="margin-top: 130px;">
          <span style="margin-left: 20px; font-size:14px; color:#909399">產品</span>
        </div>
        <van-cell-group style="margin-top: 600px; border-radius:20px; margin-top: 10px; margin-bottom:20px; max-width:640px; margin-left:7px; margin-right:7px;" :border="false">
          <van-cell style="border-radius:20px; max-width:640px; min-height: 130px;" size="large">
            <template>
              <div v-for="(item, index) in specs" :key="index">
                <van-tag  v-if="item.disabled == '1' " class="item-specs-disabled" type="danger" @click="selectSpec(index)">
                  <van-image v-if="item.img" width="40px" height="40px" fit="cover" :src="item.img" @click="onSpecImgPreview(item.img)"/>
                  <span class="item-specs-name-disabled">{{item.name}}</span>
                  <span class="item-specs-price-disabled">${{item.price}}</span>
                </van-tag>
                <van-tag  v-else-if="selectData.specid === item.id" class="item-specs-active" type="danger" @click="selectSpec(index)">
                  <van-image v-if="item.img" width="40px" height="40px" fit="cover" :src="item.img" @click="onSpecImgPreview(item.img)"/>
                  <span class="item-specs-name-active">{{item.name}}</span>
                  <span class="item-specs-price-active">${{item.price}}</span>
                </van-tag>
                <van-tag v-else class="item-specs" type="danger" plain @click="selectSpec(index)">
                  <van-image v-if="item.img" width="40px" height="40px" fit="cover" :src="item.img"/>
                  <span class="item-specs-name">{{item.name}}</span>
                  <span class="item-specs-price">${{item.price}}</span>
                </van-tag>
              </div>
            </template>
          </van-cell>
        </van-cell-group>
        <div v-for="nums in selectData.nums" :key="nums">
          <span style="margin-left: 20px; font-size:14px; color:#909399">第 {{nums}} 組</span>
          <van-cell-group class="item-pack-group" :border="false">
            <van-cell style="border-radius:20px; max-width:640px; min-height: 130px;" size="large">
              <template>
                <div v-for="(pack, title) in packageList" :key="title">
                  <div style="display:block">
                    <span style="margin-left: 5px; font-size:14px; font-weight: 900; color:#909399">{{ title }}</span>
                  </div>
                    <van-row>
                      <van-col  v-for="(item, index) in pack" :key="index">
                        <div style="margin-left:10px; margin-bottom:10px;">
                          <div v-if="item.img">
                            <van-tag  v-if="item.id === '1'" class="item-pack-disabled" type="danger" @click="selectPack(nums-1,title,index)">
                              <div style="display:block; text-align: center;">
                                <div style="position:relative; top:0; height: 5.9rem; max-height:5.9rem; min-height: 5.9rem;">
                                <van-image style="width: 100%;height: 100%; top: 0;" fit="cover" :src="item.img" @click="onSpecImgPreview(item.img)"/>
                                </div>
                                <div style="position:relative; top:0; max-height:1.4rem; min-height: 1.4rem;">
                                  <span class="item-pack-name-disabled">{{item.name}}</span>
                                </div>
                              </div>
                            </van-tag>
                            <van-tag  v-else-if="selectData.packages[nums-1][title].id === item.id" class="item-pack-active" type="danger" @click="selectPack(nums-1,title,index)">
                              <div style="display:block; text-align: center;">
                                <div style="position:relative; top:0; height: 5.9rem; max-height:5.9rem; min-height: 5.9rem;">
                                  <van-image style="width: 100%;height: 100%; top: 0;" fit="cover" :src="item.img" @click="onSpecImgPreview(item.img)"/>
                                </div>
                                <div style="position:relative; top:0; max-height:1.4rem; min-height: 1.4rem;">
                                  <span class="item-pack-name-active">{{item.name}}</span>
                                </div>
                              </div>
                            </van-tag>
                            <van-tag v-else class="item-pack" type="danger" plain @click="selectPack(nums-1,title,index)">
                              <div style="display:block; text-align: center;">
                                <div style="position:relative; top:0; height: 5.9rem; max-height:5.9rem; min-height: 5.9rem;">
                                  <van-image style="width: 100%;height: 100%; top: 0;" fit="cover" :src="item.img"/>
                                </div>
                                <div style="position:relative; top:0; max-height:1.4rem; min-height: 1.4rem;">
                                <span class="item-pack-name">{{item.name}}</span>
                                </div>
                              </div>
                            </van-tag>
                          </div>
                          <div v-else>
                            <van-tag  v-if="item.disabled === '1'" class="item-pack-nopic-disabled" type="danger" @click="selectPack(nums-1,title,index)">
                              <span class="item-pack-name-nopic-disabled">{{item.name}}</span>
                            </van-tag>
                            <van-tag  v-else-if="selectData.packages[nums-1][title].id === item.id" class="item-pack-nopic-active" type="danger" @click="selectPack(nums-1,title,index)">
                              <span class="item-pack-name-nopic-active">{{item.name}}</span>
                            </van-tag>
                            <van-tag v-else class="item-pack-nopic" type="danger" plain @click="selectPack(nums-1,title,index)">
                              <span class="item-pack-name-nopic">{{item.name}}</span>
                            </van-tag>
                          </div>
                        </div>

                      </van-col>
                    </van-row>
                </div>
              </template>
            </van-cell>
          </van-cell-group>
        </div>
        <div style="padding-bottom: 50px;"></div>
      </template>
      <van-goods-action style="max-width:640px; margin:0 auto">
        <van-goods-action-icon icon="chat-o" text="客服" @click="openchat()"/>
        <span class="action-price">NT${{specprice}}</span>
        <van-goods-action-button
          type="warning"
          color="rgba(119,167,255,1)"
          text="加入購物車"
          @click="onAddCart()"
        />
        <van-goods-action-button
          type="danger"
          color="rgba(53,120,229,1)"
          text="立即購買"
          @click="onSubmit()"
        />
      </van-goods-action>
    </van-popup>
  </div>
  <div v-else style="background-color:#f4f5f5; height:100%">
    <van-nav-bar title="訂單成功" left-text="返回" left-arrow @click-left="onClickLeft" />
    <div style="margin-left: 10px; margin-top:10px;">
      <span style="font-size:14px; color:black">商品清單</span>
    </div>
    <van-cell-group style="border-radius:20px; margin-left:7px; margin-right:7px; margin-top:10px;" :border="false">
      <van-cell style="border-radius:20px;" size="large" value="内容">
        <div style="display: inline-flex;">
          <van-image style="margin-right:10px;" width="6rem" height="6rem" fit="fill" :src="itemData.banner"/>
          <div style="display:block">
            <span class="Price-title">{{itemData.Currency}}${{resultData.price}}</span><br>
            <span style="font-size:0.6rem; font-weight:900;color: #3578e5;">{{itemData.ItemTitle}}</span><br>
            <span style="font-size:0.4rem; font-weight:900">{{resultData.content}}</span><br>
            <span style="font-size:0.4rem">建立時間：{{resultData.date}}</span>
          </div>
        </div>
        <div>
          <van-tag type="primary" size="medium">貨到付款</van-tag>
          <van-tag type="success" size="medium">宅配到府</van-tag>
          <van-tag type="danger" size="medium">客服減免</van-tag>
        <van-tag type="warning" size="medium">七日鑒賞期</van-tag>
        </div>
      </van-cell>
    </van-cell-group>
    <div style="max-width:640px; min-width:320px; margin:0 auto; text-align: center;">
      <div style="margin-left:10px; margin-top:15px; margin-right: 10px; margin-bottom:15px">
        <div class="lo-main" :class="[sharkFlag ?'my-shark' :'']" id="myShark">
          <van-tag type="danger" style=" margin-top:5px; border-radius:5px; width:280px; height: 80px;" color="linear-gradient(to right, #ff6034, #ee0a24)" @click="openchat()">
            <span class="Cost-title">NT</span><span class="Cost-Price-2">$50</span>
            <span class="Cost-Menu">現在聯絡客服本單可立減</span>
          </van-tag>
        </div>
      </div>
    </div>
    <div style="margin-left: 10px; margin-top:10px;">
      <span style="font-size:14px; color:black">配送資料</span>
    </div>
    <van-form  style="margin-top: 10px; margin-left:10px; margin-right:10px;">
      <van-field style="border-top-left-radius:20px; border-top-right-radius:20px;" readonly v-model="resultData.sn" label="訂單編號" left-icon="label-o"/>
      <van-field readonly v-model="resultData.name" label="收貨姓名" left-icon="user-o"/>
      <van-field readonly v-model="resultData.phone" label="電話號碼" left-icon="phone-o"/>
      <van-field readonly v-model="resultData.express" label="配送物流" left-icon="logistics"/>
      <van-field readonly :value="resultData.city + '/'+ resultData.region+'/'+resultData.street" label="配送地區" left-icon="location-o" />
      <van-field v-if="itemform.deliveryType === '2'" readonly v-model="resultData.shop" label="配送店鋪" left-icon="shop-o"/>
      <van-field v-if="itemform.deliveryType === '1'" readonly v-model="resultData.addr" name="pattern" label="詳細地址" left-icon="home-o"/>
      <van-field style="border-bottom-left-radius:20px; border-bottom-right-radius:20px;" readonly label="訂單備注" v-model="resultData.memo" left-icon="notes-o" />
    </van-form>
<!--     <div style="margin-left:10px; margin-top:10px;">
      <div class="fb-page" data-href="https://www.facebook.com/sctwshop" data-tabs=""  data-width="355" data-height="70" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true"><blockquote cite="https://www.facebook.com/koizumishop" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/koizumishop">小泉士多</a></blockquote></div>
    </div> -->
    <div style="margin-top:20px; padding-bottom:50px;">
      <van-collapse v-model="activeNames">
        <van-collapse-item title="用戶須知" name="1">本產品的實際使用效果根據個人情況決定，不保證每位用戶都能享受到所宣傳的效果。若有疑問請通過在線客服聯絡我們，本公司享有最終解釋權。</van-collapse-item>
        <van-collapse-item title="物流配送" name="2">貨物一般在訂單確認的5~10個工作日送達，出現突發狀況可能會有所延遲。貨物送達前都會提前聯絡客戶，請保持電話暢通。</van-collapse-item>
        <van-collapse-item title="退貨流程" name="3">確認收貨—申請退換貨—客服審核通過—用戶寄回商品—倉庫簽收驗貨—退換貨審核—退款/換貨；退換貨請註明：訂單號、姓名、電話。</van-collapse-item>
        <van-collapse-item title="關於我們" name="4">小泉士多致力於為客戶提供優質的商品，並以此爲目標不斷努力。爲了保障您的權益，購物前請認準我們的官方網站和社交媒體。</van-collapse-item>
        <van-collapse-item title="聯絡我們" name="5">如果您有問題需要幫助，可以通過在線客服與我們聯絡，或前往我們的Facebook主頁。客服電郵：support@koizumishop.com</van-collapse-item>
      </van-collapse>
    </div>
    <div style="margin:0 auto; text-align:center; padding-bottom: 80px;">
      <span style="color: #606266; font-size:0.6rem;">@小泉士多 KOIZUMISHOP</span>
      <div style="margin-top:20px;">
        <ul style="display: inline-flex;list-style: none;"><li style="margin-right: 14px;"><a style="color:#606266; text-decoration: none;font-size:0.6rem;" href="/privacy">隱私政策</a></li><li><a style="color:#606266; text-decoration: none;font-size:0.6rem;" href="/terms">服務條款</a></li></ul>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { getItem, getItemHotcakes } from '@/api/item'
import { getOrder } from '@/api/order'
import { Notify, Toast, ImagePreview } from 'vant'
import vdetails from '../components/Vdetails.vue'
import cart from '@/utils/cart'

export default {
  name: 'HelloWorld',
  components: { vdetails },
  data () {
    return {
      current: 0,
      show: false,
      result: true,
      shopName: '',
      sharkFlag: false,
      stopShark: false,
      showNotify: false,
      showShare: false,
      activeNames: [],
      options: [{ name: '複製連結', icon: 'link', type: 'link' }, { name: 'Facebook', icon: './static/icon_facebook.svg', type: 'fb' }],
      active: null,
      images: [],
      itemData: { },
      resultData: {},
      specprice: 0,
      selectData: {specid: 0, nums: 0, index: 0, packages: []},
      recomm: [],
      itemform: {uid: '', packageId: '', spec: [], price: 0, currency: ''},
      specs: [],
      packageList: [],
      orderData: [],
      details: '',
      currentPage: 1,
      total: 0,
      moreindex: 1,
      cartItemNum: cart.cartItemNum
    }
  },
  created () {
    this.getItemInfo()
    this.getRecommendInfo()
  },
  mounted () {
    setTimeout(() => {
      this.sharkFlag = true
    }, 3000)
  },
  methods: {
    loadmorerecomm () {
      var nums = 2 * this.moreindex
      getItemHotcakes({ code: this.$route.params.code, nums: 4 + nums }).then(res => {
        if (res.code === 200) {
          this.recomm = []
          this.recomm = res.data
          this.moreindex += 1
        }
      })
    },
    onSelectShare (e) {
      if (e.type === 'link') {
        this.copyLink(window.location.href)
      } else if (e.type === 'fb') {
        console.log(window.fb)
        window.FB.ui({ method: 'share', href: window.location.href }, function (response) {})
      }

      this.showShare = false
    },
    initPixel () {
      window.fbq('init', this.itemData.Pixel)
      window.fbq('track', 'PageView')
      window.fbq('track', 'ViewContent')
    },
    validator (val) {
      return /^09[0-9]{8}$/.test(val)
    },
    getItemInfo () {
      getItem({ code: this.$route.params.code }).then(res => {
        if (res.code === 200) {
          this.itemData = {}
          this.itemData = res.data
          this.itemform.uid = res.data.uid
          this.initPixel()
          this.getGoodList()
          document.title = this.itemData.ItemTitle + '-小泉士多'

          getOrder({ code: this.itemData.uid }).then(res => {
            if (res.code === 200) {
              this.orderData = []
              this.orderData = res.data
              this.total = this.orderData.length
            }
          })
        } else {
          Notify({ type: 'danger', message: '商品不存在或已下架' })
          setTimeout(() => {
            this.gotohome()
          }, 3000)
        }
      })
    },
    copyLink (val) { // 复制链接  val 就是你需要复制的链接
      this.$copyText(val).then(e => {
        Notify({ type: 'success', message: '複製成功！' })
      }, e => {
        Notify({ type: 'danger', message: '複製失敗！' })
      })
    },
    getRecommendInfo () {
      getItemHotcakes({ code: this.$route.params.code, nums: 20 }).then(res => {
        if (res.code === 200) {
          this.recomm = []
          this.recomm = res.data
        }
      })
    },
    gotoItem (link) {
      window.scrollTo(0, 0)
      this.$router.push('/' + link)
      Toast.loading({
        message: '加載中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 200
      })
      this.getItemInfo()
      this.getRecommendInfo()
    },
    gotosearch () {
      window.scrollTo(0, 0)
      this.$router.push('/search')
    },
    getGoodList () {
      this.details = this.itemData.ItemDetails
      this.details = this.details.replace(
        /<img/g,
        "<img style='display:block;width:100%;max-width:640px;border:0;overflow:clip;padding:0px;font-size:0;'"
      )
      this.details = this.details.replace(
        /<p>/g,
        '<div>'
      )
      this.details = this.details.replace(
        /<\/p>/g,
        '</div>'
      )
      /* this.details = this.details.replace(
        /src="/g,
        'authSrc="'
      ) */
      this.details = this.details.replace(
        /">/g,
        '"/>'
      )

      this.packageList = []
      this.selectData = {specid: 0, nums: 0, index: 0, packages: []}
      if (this.itemData.type === 1) {
        this.specs = this.itemData.specs
      } else {
        this.specs = this.itemData.packageLists
      }

      for (var i = 0; i < this.specs.length; i++) {
        if (!this.specs[i].disabled || this.specs[i].disabled === '0') {
          if (this.itemData.type === 2) {
            this.selectData.index = this.specs[i].speci ? this.specs[i].speci : '0'
            this.createPackage()
          }
          this.initSpec(i)
          break
        }
      }
    },
    createPackage () {
      var arr = {}
      for (var i = 0; i < this.itemData.specs.length; i++) {
        var item = this.itemData.specs[i]
        if (item.speci === this.selectData.index) {
          arr[item.title] = arr[item.title] ? arr[item.title] : []
          arr[item.title].push(item)
        }
      }
      this.packageList = arr
    },
    initselectPackge () {
      var data = []
      this.selectData.packages = []
      for (var i = 0; i < this.selectData.nums; ++i) {
        var obj = {}
        var index = 0
        for (var key in this.packageList) {
          for (var u = 0; u < this.packageList[key].length; u++) {
            if (!this.packageList[key][u].disabled || this.packageList[key][u].disabled === '0') {
              obj[key] = this.packageList[key][0]
              break
            }
          }
          index = index + 1
        }
        data.push(obj)
      }
      this.selectData.packages = data
    },
    selectPack (group, key, index) {
      if (this.packageList[key][index].disabled === '1') {
        Notify({ type: 'danger', message: '此產品缺貨，請選擇其他產品' })
        return
      }
      var data = {}
      data = this.packageList[key][index]
      this.selectData.packages[group][key] = data
      window.fbq('track', 'CustomizeProduct')
    },
    selectSpec (index) {
      if (this.specs[index].disabled === '1') {
        Notify({ type: 'danger', message: '此產品缺貨，請選擇其他產品' })
        return
      }

      this.selectData.specid = this.specs[index].id
      if (this.itemData.type === 2) {
        var nums = parseInt(this.specs[index].nums)
        this.selectData.nums = nums
        this.selectData.index = this.specs[index].speci ? this.specs[index].speci : '0'
        this.createPackage()
        this.initselectPackge()
      }
      this.specprice = this.specs[index].price
      window.fbq('track', 'CustomizeProduct')
    },
    initSpec (index) {
      this.selectData.specid = this.specs[index].id
      if (this.itemData.type === 2) {
        var nums = parseInt(this.specs[index].nums)
        this.selectData.index = this.specs[index].speci ? this.specs[index].speci : '0'
        this.selectData.nums = nums
        this.createPackage()
        this.initselectPackge()
      }
      this.specprice = this.specs[index].price
    },
    onSpecImgPreview (img) {
      ImagePreview({
        images: [img],
        closeable: true
      })
    },
    onMainImgPreview (index) {
      var images = []
      for (var i = 0; i < this.itemData.ItemMainImg.length; i++) {
        images[i] = this.itemData.ItemMainImg[i].url
      }
      ImagePreview({
        images: images,
        closeable: true,
        startPosition: index
      })
    },
    onChange (index) {
      this.current = index
    },
    onSubmit () {
      // 验证通过
      Toast.loading({
        message: '請稍後...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 500
      })
      this.itemform.price = this.specprice
      this.itemform.packageId = this.selectData.specid
      this.itemform.uid = this.itemData.uid
      this.itemform.currency = this.itemData.Currency
      this.itemform.itemTitle = this.itemData.ItemTitle
      this.itemform.itemImg = this.itemData.ItemMainImg[0].url
      this.itemform.packName = this.getSubmitPackName()
      if (this.itemData.type === 2) {
        this.itemform.spec = JSON.stringify(this.getSubmitPack())
        this.itemform.specsContent = this.getSubmitSpecContent()
      } else {
        this.itemform.spec = JSON.stringify([{id: this.itemform.packageId}])
        this.itemform.specsContent = this.getSubmitPackName()
      }

      this.$store.dispatch('checkout/initState')
      this.$store.dispatch('checkout/insertState', this.itemform)
      this.$router.push({path: '/checkout'})
    },
    onAddCart () {
      // 验证通过
      Toast.loading({
        message: '請稍後...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 500
      })
      cart.cartItemNum += 1
      this.itemform.price = this.specprice
      this.itemform.packageId = this.selectData.specid
      this.itemform.uid = this.itemData.uid
      this.itemform.currency = this.itemData.Currency
      this.itemform.itemTitle = this.itemData.ItemTitle
      this.itemform.itemImg = this.itemData.ItemMainImg[0].url
      this.itemform.packName = this.getSubmitPackName()
      if (this.itemData.type === 2) {
        this.itemform.spec = JSON.stringify(this.getSubmitPack())
        this.itemform.specsContent = this.getSubmitSpecContent()
      } else {
        this.itemform.spec = JSON.stringify([{id: this.itemform.packageId}])
        this.itemform.specsContent = this.getSubmitPackName()
      }
      window.fbq('track', 'AddToCart')
      this.$store.dispatch('cart/insertState', this.itemform)
      this.$router.push({path: '/cart'})
    },
    getSubmitPackName () {
      var name = ''
      var list = []
      if (this.itemData.type === 2) {
        list = this.itemData.packageLists
      } else {
        list = this.itemData.specs
      }

      for (var i = 0; i < list.length; i++) {
        if (list[i].id === this.itemform.packageId) {
          name = list[i].name
        }
      }
      return name
    },
    getSubmitSpecContent () {
      var name = ''
      const list = this.selectData
      for (var i = 0; i < list.packages.length; i++) {
        var item = list.packages[i]
        var spec = []
        for (var key in item) {
          spec.push({
            id: item[key].id
          })
          name += item[key].title + ':' + item[key].name + ';'
        }
      }
      return name
    },
    getSubmitPack () {
      var data = []
      for (var i = 0; i < this.selectData.packages.length; i++) {
        var item = this.selectData.packages[i]
        var spec = []
        for (var key in item) {
          spec.push({
            id: item[key].id
          })
        }
        data[i] = spec
      }
      return data
    },
    openchat () {
      window.fbq('track', 'Contact')
      window.open(this.itemData.Messager, '_blank')
    },
    gotoorder () {
      this.$router.push('/order')
      window.scrollTo(0, 0)
    },
    onClickLeft () {
      this.result = true
      this.itemform = {uid: '', packageId: '', spec: [], price: 0, currency: ''}
      this.selectSpec(0)
    },
    gotohome () {
      this.$router.push('/')
      window.scrollTo(0, 0)
      Toast.loading({
        message: '加載中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 200
      })
    },
    gotocart () {
      this.$router.push('/cart')
      window.scrollTo(0, 0)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.my-swipe {
  width: 100%;
  height: 23rem;
  width: 100%;
}
.custom-indicator {
    position: absolute;
    right: 5px;
    bottom: 5px;
    padding: 2px 5px;
    font-size: 12px;
    background: rgba(29, 29, 29, 0.3);
  }
.Price-title {
    margin-right: 4px;
    vertical-align: middle;
    color: #3578e5;
    float: left;
    font-weight: 700;
    font-size: 24px;
  }
  .OldPrice-title {
    vertical-align: middle;
    text-decoration: line-through;
    color: #333;
    float: left;
    font-size: 12px;
    padding: 0 3px;
  }
  .up-title {
    vertical-align: middle;
    color: #333;
    float: left;
    font-size: 12px;
  }
  .Cost-title {
    margin-right: 4px;
    vertical-align: middle;
    color: #ffffff;
    float: left;
    font-weight: 700;
    font-size: 14px;
  }
  .Cost-Price {
    margin-right: 4px;
    vertical-align: middle;
    color: #ffffff;
    float: left;
    font-weight: 700;
    font-size: 18px;
  }
  .Cost-Price-2 {
    margin-right: 4px;
    vertical-align: middle;
    color: #ffffff;
    float: left;
    font-weight: 700;
    font-size: 25px;
  }
  .Cost-Menu {
    margin-right: 4px;
    vertical-align: middle;
    color: #ffffff;
    float: left;
    font-weight: 700;
    font-size: 15px;
    margin-left:5px;
  }
  .Details-title {
    width: 100%;
    font-weight: 900;
    font-size: 14px;
  }
  .details {
    min-height: 600px;
    min-width: 320px;
    max-width: 640px;
    height: 100%;
    list-style: none;
    overflow: hidden;
  }
h1, h2 {
  font-weight: normal;
}
.details img {
  display: block;
  border: 0;
  min-width: 320px;
  max-width: 640px;
  overflow-clip-margin: content-box;
  overflow: clip;
}
.preview-pop {
  max-width: 640px;
  min-width: 320px;
  margin: 0 auto !important;
}
.item-pop {
  left:auto;
  height: 97%;
  min-width: 320px;
  max-width:640px;
  background-color:#f4f5f5;
}
.share-pop {
  left:auto;
  min-width: 320px;
  max-width:640px;
  background-color:#f4f5f5;
}
.item-specs-disabled {
  border-radius:4px;
  margin-bottom: 10px;
  width:97%;
  height: 55px;
  background: linear-gradient(to right, rgba(233,237,237,1) 0%, rgba(209,212,212,1) 59%);
}

.item-specs-name-disabled {
  margin-left:10px;
  font-weight: 900;
  max-width:80%;
  color: #767678;
}
.item-specs-price-disabled {
  position: absolute;
  font-weight: 900;
  font-size: 16px;
  color: #767678;
  right:5px;
}
.item-specs-active {
  border-radius:4px;
  margin-bottom: 10px;
  width:97%;
  height: 45px;
  background: linear-gradient(to right, rgba(119,167,255,1) 0%, rgba(53,120,229,1) 59%);
}

.item-specs-name-active {
  margin-left:10px;
  font-weight: 900;
  max-width:80%;
  color: white;
}
.item-specs-price-active {
  position: absolute;
  font-weight: 900;
  font-size: 16px;
  color: white;
  right:5px;
}
.item-specs {
  border-radius:4px;
  margin-bottom: 10px;
  width:97%;
  height: 42px;
  border-color: rgba(53,120,229,1);
}

.item-specs-name {
  margin-left:10px;
  font-weight: 900;
  max-width:80%;
  color: black;
}
.item-pack-group {
  border-radius:20px;
   margin-top: 10px;
   margin-bottom:20px;
   max-width:640px;
   margin-left:7px;
   margin-right:7px;
}

.item-pack-active {
  width:5.5rem;
  height:7.5rem;
  border-radius: 3px;
  background: linear-gradient(to bottom, rgba(119,167,255,1) 0%, rgba(53,120,229,1) 59%);
}
.item-pack {
  width:5.5rem;
  height:7.5rem;
  border-radius: 3px;
  border-color: rgba(53,120,229,1);
}
.item-pack-disabled {
  width:5.5rem;
  height:7.5rem;
  border-radius: 3px;
  background: linear-gradient(to bottom, rgba(233,237,237,1) 0%, rgba(209,212,212,1) 59%);
}
.item-pack-nopic-disabled {
  width:5.5rem;
  height:2.1rem;
  border-radius: 3px;
  background: linear-gradient(to right, rgba(233,237,237,1) 0%, rgba(209,212,212,1) 59%)
}
.item-pack-nopic-active {
  width:5.5rem;
  height:2.1rem;
  border-radius: 3px;
  background: linear-gradient(to right, rgba(119,167,255,1) 0%, rgba(53,120,229,1) 59%)
}
.item-pack-nopic {
  width:5.5rem;
  height:2.1rem;
  border-radius: 3px;
  border-color: rgba(53,120,229,1);
}
.item-pack-name {
  margin: 0 auto;
  font-size:0.6rem;
  font-weight: 400;
  color: black;
}
.item-pack-name-nopic
{
  margin: 0 auto;
  font-size:0.6rem;
  font-weight: 400;
  color: black;
}
.item-pack-name-active {
  margin: 0 auto;
  font-size:0.6rem;
  font-weight: 400;
  color: white;

}
.item-pack-name-nopic-active {
  margin: 0 auto;
  font-weight: 400;
  font-size:0.6rem;
  color: white;
}
.item-pack-name-disabled {
  margin: 0 auto;
  font-weight: 400;
  font-size:0.6rem;
  color: #767678;
}
.item-pack-name-nopic-disabled {
  margin: 0 auto;
  font-weight: 400;
  font-size:0.6rem;
  color: #767678;
}

.recomm-cell{
  border-radius:20px;
  padding-left: 10px !important;
  padding-right: 10px !important;
  padding-top: 0px !important;
}
.van-grid >>>.van-grid-item__content {
  padding-top: 2px !important;
  padding-left: 8px !important;
}
.recomm-swipe{
  max-width:640px;
  min-width:320px;
  margin:0 auto;
  text-align: center;
  padding-top:0px !important;
  padding:0px !important;
}
.item-specs-price {
  position: absolute;
  font-weight: 900;
  font-size: 16px;
  color: #3578e5;
  right:5px;
}
.city-pop {
  left:auto;
  height: 50%;
  min-width: 320px;
  max-width:640px;
  background-color:#f4f5f5;
}
.confirm-btn {
  background: linear-gradient(to right, rgba(119,167,255,1) 0%, rgba(53,120,229,1) 59%)
}
.cart-btn {
  background: linear-gradient(to left, rgba(119,167,255,1) 0%, rgba(53,120,229,1) 59%)
}
.action-price {
  width:120px;
  font-weight: 900;
  font-size: 20px;
  color:#3578e5;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.my-shark{
  animation:login-shake 0.8s 1 ease-in;
}
@keyframes login-shake {
  0% {transform: scale(1);}
  10%, 20% {transform: scale(0.9) rotate(-3deg);}
  30%, 50%, 70%, 90% {transform: scale(1.1) rotate(3deg);}
  40%, 60%, 80% {transform: scale(1.1) rotate(-3deg);}
  100% {transform: scale(1) rotate(0);}
}
</style>



// WEBPACK FOOTER //
// src/components/Item.vue